import { render, staticRenderFns } from "./HacizTalepList.vue?vue&type=template&id=5351a5cd&scoped=true"
import script from "./HacizTalepList.vue?vue&type=script&lang=ts"
export * from "./HacizTalepList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5351a5cd",
  null
  
)

export default component.exports